import { RouteObject } from 'react-router-dom'
import { SettingsPage } from './settings'

export const SettingsRoute: RouteObject = {
    path: '/settings',
    element: <SettingsPage />,
}
